import React from 'react'
import { Button } from 'semantic-ui-react'

const Social = ({ url, message, image }) => {
  return (
    <>
      <Button
        color="facebook"
        as="a"
        target="_blank"
        href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          url,
        )}`}
        icon="facebook f"
      />
      <Button
        color="twitter"
        as="a"
        target="_blank"
        href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
          message,
        )}&url=${encodeURIComponent(url)}`}
        icon="twitter"
      />
      <Button
        // @ts-ignore
        color="pinterest"
        as="a"
        target="_blank"
        href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
          url,
        )}&media=${encodeURIComponent(image)}&description=${encodeURIComponent(
          message,
        )}`}
        icon="pinterest p"
      />
    </>
  )
}

export default Social
